import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew, MdLens } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { institutionActions } from "./actions/institutions.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class Institution extends Component {
  componentDidMount() {
    this.getInstitution();
  }

  componentWillUnmount() {
    this.props.resetInstitution();
  }

  getInstitution = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getInstitution(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const institution = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.INSTITUTIONS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Institution: {institution && institution.code}{" "}
                  <Button
                    onClick={this.getInstitution}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Institution</dt>
              <dd className="col-sm-9">
                {institution ? (
                  institution.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Institution Code</dt>
              <dd className="col-sm-9">
                {institution ? (
                  institution.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Institution Description</dt>
              <dd className="col-sm-9">
                {institution ? (
                  institution.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Institution Status</dt>
              <dd className="col-sm-9">
                {institution ? (
                  institution.enabled ? (
                    <span>
                      <MdLens className="text-success" /> Enabled
                    </span>
                  ) : (
                    <span>
                      <MdLens className="text-danger" /> Disabled
                    </span>
                  )
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.INSTITUTIONS.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewInstitution;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getInstitution: bindActionCreators(
      institutionActions.getInstitution,
      dispatch
    ),
    resetInstitution: bindActionCreators(
      institutionActions.resetInstitution,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Institution);
